module.exports = __webpack_public_path__ + "static/img/t2.824afda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/t2.png
// module id = DqMx
// module chunks = 1